export default __webpack_public_path__ + "static/media/automated-decision-engine.daf7d7f8.png";